import { OnInit, Component, Output, EventEmitter } from '@angular/core';
import { SmartModalService } from '../../services/smart-modal.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { AsideBarService } from '../../services/asideBar.service';


@Component({
    selector: 'dhs-composite-array-object',
    templateUrl: './composite-array-object.component.html',
    styleUrls: ['./composite-array-object.component.scss'],
    standalone: false
})
export class CompositeArrayObjectComponent implements OnInit {
    fields: any = [];
    objectForm: FormGroup;
    objData: any;
    activatedResource: string;
    @Output() getData = new EventEmitter()
    configForm: any;
    decorator: any;
    btn = {
        "Add": [
            {
                "label": "ADD",
                "icon": "fa fa-plus"
            }
        ],
        "Modify": [
            {
                "label": "Update",
                "icon": "fa fa-check"
            }
        ]
    };
    action: string = 'ADD';
    constructor(
        public modalService: SmartModalService,
        public formBuilder: FormBuilder,
        public config: DialogConfig,
        public dialog: DialogRef,
        public dialogService: DialogService,
        public asideBarService: AsideBarService
    ) { }

    ngOnInit(): void {
        //overriding config in case of aside bar
        if (this['data'] != undefined && this['data'].formType != undefined && this['data'].formType === 'aside') {
            this.config.data = this['data'];
        }
        this.configForm = {
            "submitButton": true,
            "cancelButton": false,
            "filterForm": false,
            "clearOnSave": true,
            "delegateSave": true,
            "auto_fill_banner": false,
            "cancelRoute": '',
            "compositearray_action": this['data'] != undefined && this['data'].compositearray_action != undefined ? this['data'].compositearray_action : "MODIFY",//this will always be add will help us for populate
            "barcode": this['data'] != undefined && this['data'].barcode != undefined ? this['data'].barcode : false
        }
        if (this.config != undefined && this.config.data != undefined && this.config.data.parentForm != undefined) {
            this.configForm.parentForm = this.config.data.parentForm;
        }
        if (this.config != undefined && this.config.data != undefined && this.config.data.customButton != undefined) {
            this.btn = this.config.data.customButton;
        }
        let receiveddata: any = this.config.data; //this["data"];
        this.fields = receiveddata.formblocks;
        if(this.fields && this.fields.bookmark && receiveddata.resource){
            this.fields.bookmark.resource = receiveddata.resource;
        }
        if (receiveddata.decorator)
            this.decorator = receiveddata.decorator;
        if (receiveddata.banner)
            this.fields.bannerJson = receiveddata.banner;
        this.activatedResource = receiveddata.activatedResource;
        this.action = receiveddata.action
        if (receiveddata.data != null) {
            this.objData = receiveddata.data;
        }
    }

    addRow(event: any) {
        if (this['data'] != undefined && this['data'].formType != undefined && this['data'].formType === 'aside') {
            this.asideBarService.removeComponent(event);
        }
        else {
            this.dialog.close(event);
        }
    }
    getDataFn(data: any) {
        if (data.type == "form" || data.type == "mapping") {
            this.asideBarService['composite_action'] = this.action;
            this.asideBarService.setCompositeForm({ type: data.type, obj: { form: data.obj } });
        }
    }
}